export default __webpack_public_path__ + "static/media/8.c1366ed0.jpg";